/* eslint-disable object-shorthand */
/* eslint-disable max-len */
/* eslint-disable no-restricted-syntax */
import $ from 'jquery';
import _ from 'underscore';
import Promise from 'bluebird';
import { withUiBlock } from '@bingads-webui/uiblocker';
import {
  isSelectedMappingARealStore,
  isSelectedMappingANewDraftStore, isSelectedMappingANewStoreToBeCreated,
} from './grid-utils';

export const getMmcMtEndpoint = (url) => {
  let endPoint = 'https://campaign-mockci2.mmcapi.ads-int.microsoft.com/';
  if ((url.includes('ads.microsoft.com') || url.includes('bingads.microsoft.com')) &&
      !url.includes('si.bingads.microsoft.com')
  ) {
    endPoint = 'https://mmcapi.ads.microsoft.com';
  } else if (url.includes('ads-int.microsoft.com') || url.includes('si.bingads.microsoft.com')) {
    endPoint = 'https://mmcapi.ads-int.microsoft.com';
  }

  return endPoint;
};

// Inside the scope of the error function definition in the jquery.ajax object parameter's error field,
// this.data contains the request body. We can add this to the logs in the future if need be.
export const getErrorLogDetails = /* istanbul ignore next */ ({ response, url, fallbackErrorLog }) => {
  const responseText = response && response.responseText && response.responseText.substring(0, 500);
  const responseStatus = response && response.status;

  if (!_.isUndefined(responseText) && !_.isUndefined(responseStatus) && !_.isUndefined(url)) {
    return `HTTP ${response.status} ${url} with response ${responseText}`;
  } else if (!_.isUndefined(url)) {
    let error = response;
    if (_.isObject(response)) {
      error = JSON.stringify(response).substring(0, 500);
    }
    return `Encountered error with MMC API. Error: ${error}. Url: ${url}`;
  }

  return fallbackErrorLog;
};

// Tested via SI E2E tests
export const getClientIdForGMC = /* istanbul ignore next */ ({
  aid, cid, uid, onSuccess, onError, logger = null, smallToken, oAuthToken, devToken, storeId = null,
}) => {
  const browserUrl = window.location.href;
  const bmcMtEndpoint = getMmcMtEndpoint(browserUrl);
  let requestUrl;
  let requestHeaders;

  if (oAuthToken && devToken) {
    requestUrl = `${bmcMtEndpoint}/api/v1/OAuth/BingAds/GetGmcClientId`;
    requestHeaders = {
      AuthenticationToken: oAuthToken,
      DeveloperToken: devToken,
      CustomerId: cid,
      CustomerAccountId: aid,
    };
  } else {
    // When store ID is present, we need to use the OData endpoint, which generates client ID for store level
    requestUrl = storeId ? `${bmcMtEndpoint}/ODataApi/Mmc/v3/Users(${uid})/Customers(${cid})/Accounts(${aid})/Stores(${storeId})/Imports/GetGMCClientIdForFeedImport`
      : `${bmcMtEndpoint}/api/v1/BingAds/GetGmcClientId/${cid}?uid=${uid}&aid=${aid}`;
    requestHeaders = { authorization: `CCMTSmallToken ${smallToken}` };
  }

  const unblock = withUiBlock($('.gmc-to-mmc-css-wrapper'));

  $.ajax({
    url: requestUrl,
    type: 'GET',
    headers: requestHeaders,
    success: (response) => {
      unblock();
      onSuccess(response);
    },
    // Need to use a non-arrow function to access the this object passed in from
    // the func.apply call from ajaxEventInterceptor
    error: function (response) {
      unblock();
      onError();

      /* istanbul ignore next */
      if (!_.isNull(logger)) {
        let url = this && this.url;
        url = _.isUndefined(url) ? '' : url;
        const errorLogDetails = getErrorLogDetails({ response, url, fallbackErrorLog: 'MMC API - GetGmcClientId failure' });
        logger.logError(errorLogDetails);
      }
    },
  });
};

const mapTestGMCAccountToGMCEmail = /* istanbul ignore next */ ({ testGMCAccount }) => {
  if (testGMCAccount === 'bscimporttest1') {
    return 'bsc.import.test.1@gmail.com';
  } else if (testGMCAccount === 'bscimporttest2') {
    return 'bsc.import.test.2@gmail.com';
  } else if (testGMCAccount === 'bscimporttest6') {
    return 'bsc.import.test.6@gmail.com';
  } else if (testGMCAccount === 'gmctommc1') {
    return 'gmc.to.mmc.1@gmail.com';
  } else if (testGMCAccount === 'bmcimporttests02') {
    return 'bmcimporttests02@gmail.com';
  }

  return 'INVALID_TEST_GMC_ACCOUNT';
};

// Tested via SI E2E tests. Case 3 tested manually.
const createGetMappingsRequest = /* istanbul ignore next */ (
  googleMerchantIds,
  isSignedIn,
  authorizationCode,
  testGMCAccount,
  realGMCEmail,
  IsMerchantCenterImportStepAutoLoginEnabled = false
) => {
  // Case 0: Signed-out request body
  let body = {
    GoogleMerchantIdsToMatch: googleMerchantIds,
    CreatePlaceholderStores: false,
  };

  if (isSignedIn && !_.isNull(authorizationCode)) {
    // Case 1: Sign-in via Google Login Window
    body = _.extend(body, {
      AuthCode: authorizationCode,
    });
  } else if (isSignedIn && !_.isNull(realGMCEmail)) {
    // Case 2: Sign-in using GMCEmail cookie or the default Google Email
    body = _.extend(body, {
      GMCEmail: realGMCEmail,
    });

    // MMC will return object instead of auth error when send with email but without authcode in PIC backend.
    // we can remove this paramter once GA this feature and after backend remove this paramter.
    if (IsMerchantCenterImportStepAutoLoginEnabled) {
      body = _.extend(body, {
        UsingGMCEmailToSync: true,
      });
    }
  } else if (isSignedIn && !_.isNull(testGMCAccount)) {
    // Case 3: Sign-in using Google test account for developer manual testing and automated testing.
    // Requires editing the browser url.
    body = _.extend(body, {
      GMCEmail: mapTestGMCAccountToGMCEmail({ testGMCAccount }),
    });
  }

  return body;
};

// Tested via SI E2E tests
export const getMappings = /* istanbul ignore next */ ({
  authorizationCode, aid, cid, uid, googleMerchantIds, isSignedIn, onSuccess, onError, testGMCAccount, realGMCEmail, logger = null,
  smallToken, oAuthToken, devToken, IsMerchantCenterImportStepAutoLoginEnabled,
}) => {
  const browserUrl = window.location.href;
  const bmcMtEndpoint = getMmcMtEndpoint(browserUrl);
  let requestUrl;
  let requestHeaders;

  if (oAuthToken && devToken) {
    requestUrl = `${bmcMtEndpoint}/api/v1/OAuth/BingAds/MatchingStoresByGoogleMerchantIdsV2`;
    requestHeaders = {
      AuthenticationToken: oAuthToken,
      DeveloperToken: devToken,
      CustomerId: cid,
      CustomerAccountId: aid,
    };
  } else {
    requestUrl = `${bmcMtEndpoint}/api/v1/BingAds/MatchingStoresByGoogleMerchantIdsV2/${cid}?uid=${uid}&aid=${aid}`;
    requestHeaders = { authorization: `CCMTSmallToken ${smallToken}` };
  }

  const body = createGetMappingsRequest(
    googleMerchantIds,
    isSignedIn,
    authorizationCode,
    testGMCAccount,
    realGMCEmail,
    IsMerchantCenterImportStepAutoLoginEnabled
  );

  const unblock = withUiBlock($('.gmc-to-mmc-css-wrapper'));

  $.ajax({
    url: requestUrl,
    type: 'POST',
    contentType: 'application/json',
    data: JSON.stringify(body),
    headers: requestHeaders,
    success: (response) => {
      unblock();
      onSuccess(response);
    },
    // Need to use a non-arrow function to access the this object passed in from
    // the func.apply call from ajaxEventInterceptor
    error: function (response) {
      unblock();
      onError(response);

      /* istanbul ignore next */
      if (!_.isNull(logger)) {
        let url = this && this.url;
        url = _.isUndefined(url) ? '' : url;
        const errorLogDetails = getErrorLogDetails({ response, url, fallbackErrorLog: 'MMC API - MatchingStoresByGoogleMerchantIdsV2 failure' });
        logger.logError(errorLogDetails);
      }
    },
  });
};

// Tested via SI E2E tests
export const hasPlaceHolderStores = /* istanbul ignore next */ ({
  uid,
  cid,
  aid = null,
  smallToken,
  oAuthToken,
  devToken,
}) => {
  const browserUrl = window.location.href;
  const bmcMtEndpoint = getMmcMtEndpoint(browserUrl);
  let requestUrl;
  let requestHeaders;

  if (oAuthToken && devToken) {
    requestUrl = `${bmcMtEndpoint}/api/v1/OAuth/BingAds/HasPlaceholderStores`;
    requestHeaders = {
      AuthenticationToken: oAuthToken,
      DeveloperToken: devToken,
      CustomerId: cid,
      CustomerAccountId: aid,
    };
  } else {
    requestUrl = `${bmcMtEndpoint}/api/v1/BingAds/HasPlaceholderStores/${cid}?uid=${uid}`;
    if (aid !== null) {
      requestUrl = `${requestUrl}&aid=${aid}`;
    }
    requestHeaders = { authorization: `CCMTSmallToken ${smallToken}` };
  }

  return $.ajax({
    url: requestUrl,
    type: 'GET',
    headers: requestHeaders,
  });
};

export const generateSetMappingsRequest = ({
  gmcEmailAddress, i18n, mappingGridRows, logger,
}) => {
  const Mappings = [];

  for (let i = 0; i < mappingGridRows.length; i += 1) {
    const row = mappingGridRows[i];

    /* istanbul ignore else */
    if (isSelectedMappingARealStore(row)) {
      Mappings.push({
        GMCId: parseInt(row.GMCMerchantId, 10),
        MMCId: parseInt(row.SelectedMapping.MMCId, 10),
        MMCEnum: 'Existing',
      });
    } else if (isSelectedMappingANewDraftStore({ row, i18n })) {
      Mappings.push({
        GMCId: parseInt(row.GMCMerchantId, 10),
        MMCId: null,
        MMCEnum: 'Placeholder',
      });
    } else if (isSelectedMappingANewStoreToBeCreated({ row, i18n })) {
      Mappings.push({
        GMCId: parseInt(row.GMCMerchantId, 10),
        MMCId: null,
        MMCEnum: 'NewStore',
      });
    } else {
      logger.logError('BSC Import - GenerateSetMappingsRequest - selected mapping is in an unexpected format');
    }
  }

  return {
    CustomerIdAndEmailMap:
      {
        GMCEmail: gmcEmailAddress,
        Mappings,
      },
  };
};

// SetMappings is tested in Smart Import E2E SI tests
export const setMappings = /* istanbul ignore next */ ({
  customerIdAndEmailMap,
  uid,
  cid,
  aid,
  logger = null,
  smallToken,
  oAuthToken,
  devToken,
}) => {
  const browserUrl = window.location.href;
  const bmcMtEndpoint = getMmcMtEndpoint(browserUrl);
  let requestUrl;
  let requestHeaders;

  if (oAuthToken && devToken) {
    requestUrl = `${bmcMtEndpoint}/api/v1/OAuth/BingAds/SetMatchingStoresByGoogleMerchantIds`;
    requestHeaders = {
      AuthenticationToken: oAuthToken,
      DeveloperToken: devToken,
      CustomerId: cid,
      CustomerAccountId: aid,
    };
  } else {
    requestUrl = `${bmcMtEndpoint}/api/v1/BingAds/SetMatchingStoresByGoogleMerchantIds?uid=${uid}&cid=${cid}&aid=${aid}`;
    requestHeaders = { authorization: `CCMTSmallToken ${smallToken}` };
  }

  return new Promise((resolve, reject) => {
    $.ajax({
      url: requestUrl,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(customerIdAndEmailMap),
      headers: requestHeaders,
      success: (response) => {
        resolve(response);
      },
      // Need to use a non-arrow function to access the this object passed in from
      // the func.apply call from ajaxEventInterceptor
      // The error scenario is tested in Smart Import component tests
      error: /* istanbul ignore next */ function (response) {
        reject(response);

        if (!_.isNull(logger)) {
          let url = this && this.url;
          url = _.isUndefined(url) ? '' : url;
          const errorLogDetails = getErrorLogDetails({ response, url, fallbackErrorLog: 'MMC API - SetMatchingStoresByGoogleMerchantIds failure' });
          logger.logError(errorLogDetails);
        }
      },
    });
  });
};
